import React from 'react';
import Vande from '../../images/vande-nikolovski.png';
import PicOne from '../../images/picone.jpg';
import PicTwo from '../../images/pictwo.jpg';
import PicThree from '../../images/picthree.jpg';
import './ourteam.css';

const teamMembers = [
  {
    number: '01',
    name: 'Vande Nikolovski',
    role: 'Full Stack Developer',
    specialty: 'DevOps Engineering',
    imgSrc: Vande,
  },
  {
    number: '02',
    name: 'Mardin Ali Karimi',
    role: 'Communications Specialist',
    specialty: 'Brand Communication',
    imgSrc: PicThree,
  },
  {
    number: '03',
    name: 'Milad Sharifinia',
    role: 'UI/UX Specialist',
    specialty: 'Visual Design',
    imgSrc: PicOne,
  },
  {
    number: '04',
    name: 'Dino Bevehjani',
    role: 'Photographer',
    specialty: 'Visual Content',
    imgSrc: PicTwo,
  },
];

const OutTeam = () => {
  return (
    <section className="our-team-container" id="out-team">
      <div className="team-inner">
        <header className="team-heading">
          <div>
            <span className="team-eyebrow">THE PEOPLE BEHIND KODEX</span>
            <h2>Different strengths. One shared standard.</h2>
          </div>
          <div className="team-heading-copy">
            <p>
              A focused team bringing development, design, communication and
              visual thinking together around one goal: creating work that makes
              a meaningful difference for our customers.
            </p>
            <a href="#contact">
              Meet your future digital partner <span aria-hidden="true">→</span>
            </a>
          </div>
        </header>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <article className="team-card" key={member.number}>
              <div className="team-photo-wrap">
                <img
                  src={member.imgSrc}
                  alt={member.name}
                  className="team-photo"
                  loading="lazy"
                  decoding="async"
                />
                <span className="team-card-number">{member.number}</span>
                <a
                  href="#contact"
                  className="team-contact-link"
                  aria-label={`Contact ${member.name}`}
                >
                  <i className="bx bx-envelope" aria-hidden="true" />
                </a>
              </div>
              <div className="team-card-info">
                <h3>{member.name}</h3>
                <div>
                  <span>{member.role}</span>
                  <small>{member.specialty}</small>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="team-footer-line">
          <span>Small enough to stay close</span>
          <strong>Skilled enough to think bigger.</strong>
          <p>Direct collaboration. Clear responsibility. No unnecessary layers.</p>
        </div>
      </div>
    </section>
  );
};

export default OutTeam;
